// generated by the plop

import { PROGRESS_STATUSES, UUID } from 'symbols';
import { OrderModel } from '../../symbols';

export interface OrderManageStateModel {
  currentOrderId: UUID;
  orders: { [orderId: string]: OrderModel };
  loadOrderStatus: PROGRESS_STATUSES;
  updateOrderStatus: PROGRESS_STATUSES;
  realVersionOrders: { [orderId: string]: OrderModel };
}

export const ORDER_MANAGE_STATE_DEFAULT: OrderManageStateModel = {
  currentOrderId: null,
  orders: {},
  loadOrderStatus: PROGRESS_STATUSES.NOT_INITIALIZED,
  updateOrderStatus: PROGRESS_STATUSES.NOT_INITIALIZED,
  realVersionOrders: {},
};
